<template>
  <div class="ml-2 " v-bind:class="{'inline': inline, 'flex-shrink-0 flex': !inline}">
    <p v-bind:class="dynamicClasses" class=" bg-red-600 text-white px-2 text-center inline-flex text-xs leading-5 font-semibold rounded-full">
      {{count}}
    </p>
  </div>
</template>

<script>

export default {
  name: 'CounterWidget',
  props: ['count', 'position', 'inline'],
  computed: {
    dynamicClasses() {
      let classes = '';
      if (this.position) {
        classes += this.position;
      }
      return classes;
    }
  },
}
</script>
